type Props = {
  message?: string
}

export default function HelperText({ message }: Props) {
  if (!message) return null
  return <p className='text-red-500 text-sm font-semibold my-1'>{message}</p>
}
